var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW } from '@/utils/constants/popup/eventType';
import { closeProffitSearchHeaderShareModal } from '../../../actions/ProffitSearchHeaderAction';
import { apiGetListProffitSearchShareReceiveHeader } from '../../../actions/ProffitSearchReceiveHeaderAction';
import { apiGetListProffitSearchShareHeader } from '../../../actions/ProffitSearchShareHeaderAction';
import { wrapDispatch } from '../../../helpers/action';
import { isClient, isProfessional, getUserMode, isCanUseProfessionalProffit, } from '../../../helpers/auth';
import { propStr, propBool } from '../../../helpers/custom-prop-types';
import { getProffitSearchValues, isProffitSearchFreePlan, isProffitSearchTrialPlan, isProffitSearchStandardPlan, } from '../../../helpers/profile';
import { compose } from '../../../helpers/recompose';
import { useSlideSearchLockItem } from '../../../helpers/use/proffit_search/common/useSlideSearchLockItem';
import { useBoolState, useUnmountRef } from '../../../helpers/use/useHook';
import BeginnerIcon from '../../Icon/Svg/BeginnerIcon';
import ProfileSimpleIcon from '../../Icon/Svg/ProfileSimpleIcon';
import SlideSearchAccountIcon from '../../Icon/Svg/SlideSearchAccountIcon';
import SlideSearchFolderIcon from '../../Icon/Svg/SlideSearchFolderIcon';
import SlideSearchMembersIcon from '../../Icon/Svg/SlideSearchMembersIcon';
import SlideSearchPicturePlusIcon from '../../Icon/Svg/SlideSearchPicturePlusIcon';
import SlideSearchShareIcon from '../../Icon/Svg/SlideSearchShareIcon';
import SlideSearchRegistrationModals from '../../SlideSearch/Common/Modal/SlideSearchRegistrationModals';
import ModalPortal from '../../Ui/Modal/ModalPortal';
import TransitionHoc from '../../Ui/Transition/TransitionHoc';
import SlideSearchHeaderSideMenu from './Parts/SideMenu';
import SlideSearchHeaderActionButton from './Parts/SlideSearchHeaderActionButton';
import SlideSearchHeaderIcons from './Parts/SlideSearchHeaderIcons';
import SlideSearchHeaderLogo from './Parts/SlideSearchHeaderLogo';
import SlideSearchHeaderPlan from './Parts/SlideSearchHeaderPlan';
import SlideSearchHeaderShareModal from './Parts/SlideSearchHeaderShareModal';
const SlideSearchHeader = (props) => {
    const { className, isShowTransition: isShowHeader, transitionState } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const location = useLocation();
    const auth = useSelector((state) => state.auth);
    const profile = useSelector((state) => state.profile);
    const popups = useSelector((state) => state.popup);
    const receive = useSelector((state) => state.proffitSearchReceiveHeader);
    const share = useSelector((state) => state.proffitSearchShareHeader);
    const { isHeaderShareModalClosed } = useSelector((state) => state.proffitSearchHeader);
    const reducerRef = useRef({});
    reducerRef.current = { isHeaderShareModalClosed, receive };
    const userMode = getUserMode(auth);
    const isClientUser = isClient(auth);
    const isProfessionalUser = isProfessional(auth);
    const { canRegistrationTrial, freeAccountCount, hasTrialEndAt, isExpireApproach, isExpired, isGroupAdmin, plan, standardCountDown, standardTimeCountDown, trialCountDown, trialTimeCountDown, } = useMemo(() => getProffitSearchValues(profile), [profile]);
    const isTrial = isProffitSearchTrialPlan(plan);
    const isFree = isProffitSearchFreePlan(plan);
    const isStandard = isProffitSearchStandardPlan(plan);
    // 初回チュートリアル完了フラグ
    const isShowSearchFirstView = useMemo(() => {
        const { viewPopups } = profile || {};
        return popups.accessEvent[POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW]
            ? false
            : (viewPopups || []).includes(POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW);
    }, [profile, popups.accessEvent]);
    const { boolState: isShowMenu, changeFalse: hideMenu, changeToggle: toggleMenu, } = useBoolState(false);
    const { boolState: isShowShareModal, changeFalse: rawHideShareModal, changeToggle: toggleShareModal, changeTrue: showShareModal, } = useBoolState(false);
    const useLockItem = useSlideSearchLockItem.useSlideSearchLockItemModal(profile, userMode, dispatch, unmountRef);
    /**
     * ヘッダーのアイコンリンク一覧。ユーザーの状態に応じて各リンクの挙動を制御する
     * @type {*}
     */
    const links = useMemo(() => {
        const path = location.pathname.replace(/\/$/, '');
        const isFolderActive = [
            '/proffit_search/folder',
            '/proffit_search/receive_folder',
            '/proffit_search/share_history',
            '/proffit_search/upload_history',
        ].some((v) => path.indexOf(v) === 0);
        const isAccountActive = [
            '/proffit_search/account_list',
            '/proffit_search/account_plan',
        ].some((v) => path.indexOf(v) === 0);
        const isAddMemberActive = path === '/proffit_search/account_add';
        // アカウント管理のリンク
        let accountListProps = { to: '/proffit_search/account_list' };
        // グループ責任者でない場合にのみ、プランに応じて挙動を変える
        if (!isGroupAdmin && !isExpired) {
            if (isFree) {
                // フリープランの場合：トライアル未経験は登録モーダル表示、トライアル終了済みであればプラン画面に飛ばす
                accountListProps = {
                    onClick: hasTrialEndAt ? undefined : useLockItem.showFormModal,
                    to: '/proffit_search/account_plan',
                };
            }
            else if (isTrial) {
                // トライアルプランの場合はプラン画面に飛ばす
                accountListProps = { to: '/proffit_search/account_plan' };
            }
        }
        return {
            accountList: Object.assign({ className: clsx('account', isAccountActive && 'active', freeAccountCount > 0 && 'unused'), icon: _jsx(SlideSearchAccountIcon, { className: 'svg_account' }), text: 'アカウント管理' }, accountListProps),
            addAccount: {
                className: clsx('members', isAddMemberActive && 'active'),
                icon: _jsx(SlideSearchMembersIcon, { className: 'svg_members' }),
                text: 'メンバー追加',
                to: '/proffit_search/account_add',
            },
            addSlide: {
                className: 'slide',
                icon: _jsx(SlideSearchPicturePlusIcon, { className: 'svg_slide' }),
                isDisabled: isFree,
                onClick: isFree ? useLockItem.onClickLockItem : undefined,
                text: 'スライドをストックする',
                to: '/proffit_search/slide_add',
            },
            beginner: {
                className: 'beginner',
                icon: _jsx(BeginnerIcon, { className: 'svg_beginner' }),
                text: '使い方',
                to: '/proffit_search/lp',
            },
            folder: {
                className: clsx('folder', isFolderActive && 'active'),
                icon: _jsx(SlideSearchFolderIcon, { className: 'svg_folder' }),
                text: 'フォルダ',
                to: '/proffit_search/folder',
            },
            profile: {
                className: 'profile',
                icon: _jsx(ProfileSimpleIcon, { className: 'svg_profile' }),
                text: 'プロフィール',
                to: '/mypage/profile',
            },
            share: {
                className: clsx('share', isShowShareModal && 'active', receive.unreadCount > 0 && 'unread'),
                icon: _jsx(SlideSearchShareIcon, { className: 'svg_share' }),
                onClick: toggleShareModal,
                text: '共有状況',
                to: '',
            },
        };
    }, [
        freeAccountCount,
        hasTrialEndAt,
        isExpired,
        isFree,
        isGroupAdmin,
        isShowShareModal,
        isTrial,
        location.pathname,
        receive.unreadCount,
        toggleShareModal,
        useLockItem.showFormModal,
        useLockItem.onClickLockItem,
    ]);
    /**
     * ユーザーの条件に応じてテキストや挙動を変える
     * @type {*}
     */
    const actionButtonProps = useMemo(() => {
        const to = '/mypage';
        // 企業ユーザーの場合
        if (isClientUser) {
            // TODO: マイページ表示済みかの判定が実装され次第、正しいキーに差し替える
            const isOpenedMyPage = !!profile.isOpenedMyPage;
            return {
                textComponent: (_jsx("span", Object.assign({ className: 'text_inner' }, { children: isOpenedMyPage ? (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: 'xl-is-dnone' }, { children: "Proffit\u3067" })), "\u30B3\u30F3\u30B5\u30EB\u30FB\u30CE\u30A6\u30CF\u30A6\u3092", _jsx("br", { className: 'text_break xl-is-show' }), "\u63A2\u3059"] })) : (_jsxs(_Fragment, { children: ["\u8ABF\u67FB\u30FB\u8CC7\u6599\u4F5C\u308A\u3092", _jsx("br", { className: 'xl-is-show' }), "\u4F9D\u983C\u3057\u305F\u3044"] })) }))),
                textPlain: isOpenedMyPage
                    ? 'Proffitでコンサル・ノウハウを探す'
                    : '調査・資料作りを依頼したい',
                to,
            };
        }
        // コンサルタントの場合
        return {
            textComponent: (_jsxs("span", Object.assign({ className: 'text_inner' }, { children: [_jsx("span", Object.assign({ className: 'xl-is-dnone' }, { children: "Proffit\u3067" })), "\u52DF\u96C6\u3057\u3066\u3044\u308B", _jsx("br", { className: 'text_break xl-is-show' }), "\u6848\u4EF6\u3092\u898B\u308B"] }))),
            textPlain: 'Proffitで募集している案件を見る',
            to,
        };
    }, [isClientUser, profile]);
    /**
     * コンサルかつProffit未利用のユーザー（組織審査が必要なユーザー）の場合は非表示、それ以外のユーザーの場合はProffitへのリンクを表示する
     * @type {boolean}
     */
    const isShowActionButton = useMemo(() => !(isProfessionalUser && !isCanUseProfessionalProffit(profile)), [isProfessionalUser, profile]);
    /**
     * reducer上の共有状況モーダル表示フラグを折る
     * @type {(function(): void)|*}
     */
    const hideReducerModal = useCallback(() => {
        dispatch(closeProffitSearchHeaderShareModal());
    }, [dispatch]);
    /**
     * 共有状況モーダルを閉じる
     * @type {(function(): void)|*}
     */
    const hideShareModal = useCallback(() => {
        hideReducerModal();
        rawHideShareModal();
    }, [hideReducerModal, rawHideShareModal]);
    // PC/SPで使い回すために変数化
    const planComponent = (_jsx(SlideSearchHeaderPlan, { canRegistrationTrial: canRegistrationTrial, isExpireApproach: isExpireApproach, isFree: isFree, isStandard: isStandard, isTrial: isTrial, plan: plan, showFormModal: useLockItem.showFormModal, standardCountDown: standardCountDown, standardTimeCountDown: standardTimeCountDown, trialCountDown: trialCountDown, trialTimeCountDown: trialTimeCountDown }));
    useEffect(() => {
        // データの読み込み処理
        const loadItems = () => __awaiter(void 0, void 0, void 0, function* () {
            yield Promise.all([
                wrapDispatch(dispatch, apiGetListProffitSearchShareReceiveHeader()),
                wrapDispatch(dispatch, apiGetListProffitSearchShareHeader()),
            ]);
            // チュートリアルが完了しており、モーダルが一度も閉じられておらず、かつ未読の受領スライドが存在する場合にモーダル初期表示
            if (!unmountRef.current &&
                !reducerRef.current.isHeaderShareModalClosed &&
                reducerRef.current.receive.unreadCount > 0 &&
                !isShowSearchFirstView) {
                showShareModal();
            }
        });
        loadItems().then();
        // ページ離脱時にモーダルを閉じる
        return () => {
            hideReducerModal();
        };
    }, [
        dispatch,
        hideReducerModal,
        isShowSearchFirstView,
        reducerRef,
        showShareModal,
        unmountRef,
    ]);
    return (_jsxs("header", Object.assign({ className: `l-header slide_search_header animated-opacity ${className} ${transitionState}` }, { children: [_jsxs("div", Object.assign({ className: 'l-container header_inner' }, { children: [_jsx("div", Object.assign({ className: 'header_logo' }, { children: _jsx(SlideSearchHeaderLogo, {}) })), _jsx("div", Object.assign({ className: 'header_action' }, { children: isShowActionButton && (_jsx(SlideSearchHeaderActionButton, { isNoLinkComponent: actionButtonProps.isNoLinkComponent, onClickNoLink: actionButtonProps.onClickNoLink, textComponent: actionButtonProps.textComponent, to: actionButtonProps.to })) })), _jsx("div", Object.assign({ className: 'header_plan' }, { children: planComponent })), _jsx("div", Object.assign({ className: 'header_icons' }, { children: _jsx(SlideSearchHeaderIcons, { links: links }) })), _jsx("div", Object.assign({ className: 'header_menu' }, { children: _jsx(SlideSearchHeaderSideMenu, { actionButtonProps: actionButtonProps, hideMenu: hideMenu, isShowMenu: isShowMenu, links: links, planComponent: planComponent, profile: profile, toggleMenu: toggleMenu }) }))] })), _jsxs(ModalPortal, { children: [_jsx(SlideSearchHeaderShareModal, { hideModal: hideShareModal, isShow: isShowShareModal && isShowHeader, receive: receive, share: share }), _jsx(SlideSearchRegistrationModals, { canRegistrationTrial: canRegistrationTrial, email: useLockItem.email, hideCompleteModal: useLockItem.hideCompleteModal, hideFormModal: useLockItem.hideFormModal, hidePaidModal: useLockItem.hidePaidModal, initialValues: useLockItem.initialValues, isShowCompleteModal: useLockItem.isShowCompleteModal && isShowHeader, isShowFormModal: useLockItem.isShowFormModal && isShowHeader, isShowPaidModal: useLockItem.isShowPaidModal && isShowHeader, kanaRef: useLockItem.kanaRef, onSubmitRegistration: useLockItem.onSubmitRegistration, userMode: userMode })] })] })));
};
SlideSearchHeader.propTypes = {
    className: propStr(),
    isShowTransition: propBool().isRequired,
    transitionState: propStr().isRequired,
};
SlideSearchHeader.defaultProps = {
    className: '',
};
const enhance = compose(TransitionHoc);
export default enhance(SlideSearchHeader);
